import React from "react";
import { FieldError, UseFormRegisterReturn } from "react-hook-form";
import { FormRow } from "./FormRow";

export interface SelectOption {
  value: string | number;
  label?: string;
  disabled?: boolean;
}

interface SelectInputProps {
  label: string;
  registration?: UseFormRegisterReturn;
  options: SelectOption[];
  required?: boolean;
  error?: FieldError;
  value?: string | number;
  onChange?: (e: React.ChangeEvent<HTMLSelectElement>) => void;
}

export const SelectInput: React.FC<SelectInputProps> = ({
  label,
  registration,
  options,
  required = false,
  error,
  value,
  onChange,
}) => {
  const selectProps = registration
    ? { ...registration }
    : {
        value,
        onChange,
      };

  return (
    <FormRow label={label} required={required} error={error}>
      <select {...selectProps}>
        {options.map((option) => (
          <option
            key={option.value}
            value={String(option.value)}
            disabled={option.disabled}
          >
            {option.label || option.value}
          </option>
        ))}
      </select>
    </FormRow>
  );
};
